export function flattenMenus(menus) {
  const result = [];

  function traverse(menu) {
    result.push(menu);
    if (menu.sousMenus) {
      menu.sousMenus.forEach(traverse);
    }
  }

  menus.forEach(traverse);
  return result;
}


export function findIconByKey(menus, path) {
    const menu = menus.find((menu) => "/" + menu.to?.toLowerCase() === path?.toLowerCase());
    return menu?.headerIcon;
  }